import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';



export async function preInsert(entity, data) {

    var d = { ...data }

    if (entity === 'sample') {
        d.sample1 = 'test'
    }
    if (entity === "job_request") {
        console.log(data)
        if (data.source && data.source === "10_AGENCY") {
            if (data.idAgency === null) {
                toast.error("Selezionare un'agenzia per continuare.", { theme: 'colored' })
                return {
                    success: 0,
                    data: d,
                    message: 'Il campo Agenzia deve essere compilato'
                }
            }
        }
        console.log(localStorage.getItem("idJobPost"))
        var res = await DataManager.getItem('job_post', localStorage.getItem("idJobPost"))
        console.log(res)
        if (res.success === 1) {
            var count = res.body[0].questions.length;
            console.log(data.answer.length, count)
            if (data.answer.length < count) {
                toast.error("È obbligatorio compilare tutte le risposte per proseguire. Risposte mancanti: " + (count - data.answer.length), {theme: 'colored'})
                return {
                    success: 0,
                    data: d,
                    message: 'È obbligatorio compilare tutte le risposte per proseguire.'
                }
            }
        }



    }

    return {
        success: 1,
        data: d,
        message: ''
    }
}